@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package com.haeyum.kug_seoul.generated.resources

import kotlin.OptIn
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.FontResource

@ExperimentalResourceApi
private object Font0 {
  public val Pretendard_Black: FontResource by 
      lazy { init_Pretendard_Black() }

  public val Pretendard_Bold: FontResource by 
      lazy { init_Pretendard_Bold() }

  public val Pretendard_ExtraBold: FontResource by 
      lazy { init_Pretendard_ExtraBold() }

  public val Pretendard_ExtraLight: FontResource by 
      lazy { init_Pretendard_ExtraLight() }

  public val Pretendard_Light: FontResource by 
      lazy { init_Pretendard_Light() }

  public val Pretendard_Medium: FontResource by 
      lazy { init_Pretendard_Medium() }

  public val Pretendard_Regular: FontResource by 
      lazy { init_Pretendard_Regular() }

  public val Pretendard_SemiBold: FontResource by 
      lazy { init_Pretendard_SemiBold() }

  public val Pretendard_Thin: FontResource by 
      lazy { init_Pretendard_Thin() }
}

@ExperimentalResourceApi
internal val Res.font.Pretendard_Black: FontResource
  get() = Font0.Pretendard_Black

@ExperimentalResourceApi
private fun init_Pretendard_Black(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Pretendard_Black",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/Pretendard-Black.otf"),
    )
)

@ExperimentalResourceApi
internal val Res.font.Pretendard_Bold: FontResource
  get() = Font0.Pretendard_Bold

@ExperimentalResourceApi
private fun init_Pretendard_Bold(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Pretendard_Bold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/Pretendard-Bold.otf"),
    )
)

@ExperimentalResourceApi
internal val Res.font.Pretendard_ExtraBold: FontResource
  get() = Font0.Pretendard_ExtraBold

@ExperimentalResourceApi
private fun init_Pretendard_ExtraBold(): FontResource =
    org.jetbrains.compose.resources.FontResource(
  "font:Pretendard_ExtraBold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/Pretendard-ExtraBold.otf"),
    )
)

@ExperimentalResourceApi
internal val Res.font.Pretendard_ExtraLight: FontResource
  get() = Font0.Pretendard_ExtraLight

@ExperimentalResourceApi
private fun init_Pretendard_ExtraLight(): FontResource =
    org.jetbrains.compose.resources.FontResource(
  "font:Pretendard_ExtraLight",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/Pretendard-ExtraLight.otf"),
    )
)

@ExperimentalResourceApi
internal val Res.font.Pretendard_Light: FontResource
  get() = Font0.Pretendard_Light

@ExperimentalResourceApi
private fun init_Pretendard_Light(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Pretendard_Light",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/Pretendard-Light.otf"),
    )
)

@ExperimentalResourceApi
internal val Res.font.Pretendard_Medium: FontResource
  get() = Font0.Pretendard_Medium

@ExperimentalResourceApi
private fun init_Pretendard_Medium(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Pretendard_Medium",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/Pretendard-Medium.otf"),
    )
)

@ExperimentalResourceApi
internal val Res.font.Pretendard_Regular: FontResource
  get() = Font0.Pretendard_Regular

@ExperimentalResourceApi
private fun init_Pretendard_Regular(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Pretendard_Regular",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/Pretendard-Regular.otf"),
    )
)

@ExperimentalResourceApi
internal val Res.font.Pretendard_SemiBold: FontResource
  get() = Font0.Pretendard_SemiBold

@ExperimentalResourceApi
private fun init_Pretendard_SemiBold(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Pretendard_SemiBold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/Pretendard-SemiBold.otf"),
    )
)

@ExperimentalResourceApi
internal val Res.font.Pretendard_Thin: FontResource
  get() = Font0.Pretendard_Thin

@ExperimentalResourceApi
private fun init_Pretendard_Thin(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Pretendard_Thin",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "font/Pretendard-Thin.otf"),
    )
)
